export default "__VITE_ASSET__DIaIEJNU__"